<!-- Slim top bar only when not using the in-app admin shell (avoids double header + old dark bar) -->
<app-admin-header *ngIf="isAdminPanel && !isAdminDashboardShell"></app-admin-header>

<div class="main-content-wrapper">
  <router-outlet></router-outlet>
</div>

<!-- Toast Notifications -->
<app-toast></app-toast>
